import { Component } from '@angular/core';
import { CardComponent, ItemService, MessageService } from '@spartacus/organization/administration/components';

@Component({
    selector: 'app-uig-card',
    templateUrl: './uig-card.component.html',
    styleUrls: ['./uig-card.component.scss'],
    standalone: false,
    providers: [MessageService],
})
export class UigCardComponent<T = any> extends CardComponent<T> {

  constructor(
    itemService: ItemService<T>,
    messageService: MessageService
  ) {
    super(itemService, messageService);
  }
}
